import React, { useEffect, useState } from 'react';
import { HelpCircle } from 'lucide-react';
import { useTranslation } from '../../../hooks/useTranslation.jsx';
import useManualInput from './useManualInput';
import { Box, TextArea, Row, Button, Note } from './manualInputStyles';

/** What-if (HMW) questions by hand (#687): one question per line; saving replaces the list. */
export default function HmwQuestionsAdmin({ instanceId, locked = false, onApplied }) {
  const { t } = useTranslation();
  const { context, busy, error, run } = useManualInput(instanceId, 'hmw_questions_bootstrap', { onApplied });
  const [text, setText] = useState('');
  const [saved, setSaved] = useState(null);

  useEffect(() => {
    if (context) setText(context.questions.join('\n'));
  }, [context]);

  const questions = text.split('\n').map((q) => q.trim()).filter(Boolean);
  const save = async () => {
    const data = await run('apply', { questions });
    if (data) setSaved(data.seed?.stored ?? questions.length);
  };

  return (
    <Box>
      <h3>{t('manualInputs.hmw.title')}</h3>
      <p className="intro">{t('manualInputs.hmw.intro')}</p>
      <TextArea
        value={text}
        onChange={(e) => { setText(e.target.value); setSaved(null); }}
        placeholder={t('manualInputs.hmw.placeholder')}
        disabled={busy || locked}
      />
      <Row>
        <Button type="button" $primary onClick={save} disabled={busy || locked || !context}>
          <HelpCircle size={16} /> {busy ? t('manualInputs.saving') : t('manualInputs.hmw.save', { count: questions.length })}
        </Button>
      </Row>
      {saved != null && <Note>{t('manualInputs.hmw.saved', { count: saved })}</Note>}
      {error && <Note $error>{error}</Note>}
      {locked && <Note $warn>{t('manualInputs.locked')}</Note>}
    </Box>
  );
}
